export default {
  // Navigation
  nav: {
    services: 'Servicios',
    cases: 'Casos',
    about: 'Sobre nosotros',
    team: 'Equipo',
    contact: 'Contacto',
    language: 'Idioma'
  },

  // Hero Section
  hero: {
    title: 'Marketing Sistemático e Inteligencia Artificial: Tu clave para el crecimiento estable de ventas',
    subtitle: 'Convertimos el caos en sistema. Combinamos experiencia experta con precisión de algoritmos de IA para escalar tu negocio.',
    cta1: 'Obtener estrategia de crecimiento',
    cta2: 'Discutir proyecto',
    modalTitle: '¿Tu marketing funciona al 100% o desperdicia presupuesto?',
    modalSubtitle: 'No adivines. Obtén una visión honesta desde fuera. Regístrate para un diagnóstico express gratuito de 20 minutos de tu proyecto.',
    modalBenefitsTitle: 'Lo que descubrirás:',
    modalBenefit1: 'Dónde estás perdiendo clientes ahora mismo (búsqueda de "agujeros" en el embudo)',
    modalBenefit2: '3 puntos de crecimiento no obvios para escalar ingresos',
    modalBenefit3: 'Cómo la IA puede reducir tus gastos publicitarios',
    formName: 'Nombre',
    formPhone: 'Teléfono',
    formWebsite: 'Enlace al sitio web',
    formWebsiteOptional: '(opcional)',
    formSubmit: 'Registrarse para diagnóstico',
    formConsent: 'Al hacer clic en el botón, aceptas la política de privacidad',
    formSuccess: '¡Solicitud enviada! Nos pondremos en contacto contigo pronto.',
    formError: 'Ocurrió un error. Inténtalo de nuevo.'
  },

  // Pain Points
  painPoints: {
    title: '¿Situación familiar?',
    point1Title: 'Contratas freelancers puntualmente',
    point1Desc: '¿Y esperas un milagro que nunca sucede?',
    point2Title: 'Desperdicias presupuestos',
    point2Desc: '¿En Yandex y Google sin resultados visibles?',
    point3Title: 'Tienes la sensación',
    point3Desc: '"Estoy haciendo algo mal", pero no entiendes cómo arreglarlo?',
    conclusion: 'Las acciones caóticas sin sistema solo conducen a pérdida de tiempo y dinero'
  },

  // Solution
  solution: {
    title: '¿Qué es el marketing sistemático?',
    subtitle: 'Tu clave para el crecimiento estable y las ventas',
    problemTitle: 'El caos de marketing es el enemigo de tu beneficio',
    problemDesc: 'La mayoría de las empresas viven en un estado de "caos de marketing": lanzamientos puntuales de publicidad, cambio de contratistas, falta de comprensión de qué rublo trajo beneficio y cuál se desperdició.',
    definitionTitle: 'El marketing sistemático es lo opuesto al caos',
    definitionDesc1: 'Es un enfoque en el que el marketing se considera no como un conjunto de acciones dispersas (lanzamos Direct, escribimos una publicación), sino como un organismo único que trabaja para un resultado financiero predecible.',
    definitionDesc2: 'Es la base gracias a la cual los clics se convierten en clientes reales y leales, y cada rublo invertido trae beneficio medible.',
    pillarsTitle: 'Tres pilares del marketing sistemático',
    pillarsSubtitle: 'Unidad de tres elementos',
    pillarsDesc: 'El marketing sistemático se basa en la sinergia de tres componentes clave que funcionan como un mecanismo único',
    pillar1: 'Estrategia',
    pillar1Subtitle: 'Cerebro del sistema',
    pillar1Desc: 'Comprensión de a quién, dónde y cómo atraemos',
    pillar2: 'Herramientas',
    pillar2Subtitle: 'Manos del sistema',
    pillar2Desc: 'Implementación técnica de la estrategia',
    pillar3: 'Equipo',
    pillar3Subtitle: 'Corazón del sistema',
    pillar3Desc: 'Personas que gestionan las herramientas',
    resultsTitle: 'Tu éxito y beneficio no es casualidad',
    resultsSubtitle: 'Es el resultado de algoritmos inteligentes y estrategia impecable. Construimos para ti un departamento de marketing potente y autónomo.',
    result1Title: 'Control y Transparencia',
    result1Desc: 'Siempre sabes cuánto beneficio trae cada rublo invertido en tráfico.',
    result2Title: 'Lealtad y Comunidad',
    result2Desc: 'Las redes sociales dejan de ser una "tarjeta de visita" y se convierten en una herramienta de ventas repetidas.',
    result3Title: 'Ahorro de tiempo',
    result3Desc: 'La automatización libera tu tiempo para la gestión estratégica, eliminando la rutina.',
    result4Title: 'Dominio en Ozon',
    result4Desc: 'Crecimiento predecible de facturación y productos en el top.'
  },

  // Services
  services: {
    title: 'Nuestros Servicios',
    subtitle: 'Elige una solución lista o crearemos una estrategia individual para tu negocio',
    calculateCost: 'Calcular costo de servicios',
    discussEcosystem: 'Discutir ecosistema',
    getPlan: 'Obtener plan de desarrollo',
    findGrowthPoints: 'Descubrir puntos de crecimiento',
    discussPartnership: 'Discutir asociación',
    calculateUnitEconomics: 'Calcular economía unitaria',
    standardServicesTitle: 'Conjunto de herramientas digitales para el crecimiento',
    standardServicesSubtitle: 'Publicidad contextual • Publicidad dirigida • SMM • Creación de sitios web',
    standardServicesDesc: 'Elige herramientas individuales para fortalecer tu marketing puntualmente o úsalas en conjunto para máximo efecto'
  },

  // Cases
  cases: {
    title: 'Casos: Cómo funciona el sistema en la práctica',
    subtitle: 'No ocultamos resultados. Aquí hay ejemplos de cómo la implementación de estrategia y análisis integral afecta los ingresos en tiempo real.'
  },

  // About
  about: {
    title: 'Evolución de Experto Top a Fundador',
    subtitle: 'No creemos en el marketing intuitivo. Creemos en la precisión de datos, profundidad de psicología y velocidad de algoritmos. Nuestra empresa es una simbiosis de educación académica, práctica dura en agencias líderes y tecnologías avanzadas.',
    founderTitle: 'Fundador e Ideólogo',
    founderName: 'Irina Sharova-Yalynpala',
    founderRole: 'Fundador de la agencia, Director de Marketing, Experto en crecimiento sistemático',
    founderQuote: 'Mi objetivo es convertir tu marketing de un "agujero negro" para el presupuesto en un activo gestionable que trae beneficio 24/7.',
    journeyTitle: 'De mejor estudiante a Propio Negocio',
    journeySubtitle: 'Camino desde educación académica a través del trabajo en agencia top hasta crear propia empresa',
    aiPhilosophyTitle: '¿Por qué la IA está en la base de la empresa?',
    aiPhilosophyDesc: 'En la lista de mis habilidades profesionales siempre estuvo el punto: "Capacidad de analizar gran volumen de datos". Antes esto tomaba semanas. Ahora, como fundador, implementé Inteligencia Artificial en todos los procesos de la agencia.',
    teamTitle: 'Expertos que trabajan en tu éxito',
    teamSubtitle: 'Cada miembro de nuestro equipo es especialista con experiencia confirmada en su área'
  },

  // How We Work
  howWeWork: {
    title: 'Cómo trabajamos',
    subtitle: '5 etapas de construcción del sistema — proceso paso a paso de transformación de tu marketing',
    step1: 'Digitalización y Análisis',
    step2: 'Diseño de Embudo de Ventas',
    step3: 'Prueba de Hipótesis',
    step4: 'Escalamiento',
    step5: 'Automatización',
    benefitsTitle: 'El enfoque sistemático permite al dueño del negocio:',
    benefit1: 'Ver ingresos reales',
    benefit2: 'Decisiones basadas en cifras',
    benefit3: 'Transportador predecible'
  },

  // Why Us
  whyUs: {
    title: '¿Por qué nosotros?',
    subtitle: 'Somos tu socio estratégico, no solo un contratista',
    reason1Title: 'Garantía basada en IA',
    reason1Desc: 'Basamos gastos en modelos precisos, no en conjeturas. La inteligencia artificial analiza millones de datos para tomar decisiones óptimas.',
    reason2Title: 'Arma secreta',
    reason2Desc: 'Tecnologías que tus competidores no tienen. Usamos herramientas de IA avanzadas para pronóstico y automatización.',
    reason3Title: 'Tu tiempo es valor',
    reason3Desc: 'Tomamos la rutina nosotros, tú te ocupas del negocio. La automatización completa de procesos libera tus recursos para desarrollo estratégico.',
    statsProjects: 'Proyectos exitosos',
    statsGrowth: 'Crecimiento promedio de ventas',
    statsClients: 'Clientes satisfechos'
  },

  // Results
  results: {
    title: '¿Qué obtendrás después de implementar el sistema?',
    subtitle: 'Resultados concretos que cambiarán tu negocio',
    result1Title: 'Control total y transparencia de gastos',
    result1Desc: 'Ves cada rublo y entiendes a dónde va y qué resultado trae',
    result2Title: 'Crecimiento sistemático de ingresos cada mes',
    result2Desc: 'Aumento predecible de beneficio gracias a procesos ajustados',
    result3Title: 'Departamento de marketing autónomo',
    result3Desc: 'El sistema funciona sin tu participación constante, liberando tiempo para el negocio',
    result4Title: 'Dominio en Ozon y buscadores',
    result4Desc: 'Tus productos y servicios en primeras posiciones, adelantando a competidores',
    result5Title: 'Flujo de clientes leales',
    result5Desc: 'No solo compradores, sino defensores de marca que regresan',
    result6Title: 'Optimización de presupuesto hasta 40%',
    result6Desc: 'Los algoritmos de IA encuentran los canales más efectivos y eliminan los que no funcionan',
    ctaTitle: '¿Listo para la transformación?',
    ctaSubtitle: 'Verás los primeros resultados en 30 días después del lanzamiento del sistema',
    ctaButton: 'Comenzar ahora mismo'
  },

  // Lead Form
  leadForm: {
    title: '¿Listo para convertir el caos en crecimiento estable?',
    subtitle: 'Deja una solicitud para un diagnóstico gratuito de tu marketing. Mostraremos puntos de crecimiento con análisis de IA.',
    benefit1Title: 'Análisis profundo',
    benefit1Desc: 'Estudiaremos tu negocio y competidores con ayuda de IA',
    benefit2Title: 'Presentación personal',
    benefit2Desc: 'Mostraremos puntos de crecimiento concretos y estrategia',
    benefit3Title: 'Bonificación',
    benefit3Desc: 'Lista de verificación de mejoras rápidas que se pueden implementar de inmediato',
    formTitle: 'Registrarse para diagnóstico',
    formSubtitle: 'Completa el formulario y nos pondremos en contacto contigo en una hora',
    formName: 'Tu nombre',
    formPhone: 'Teléfono',
    formWebsite: 'Sitio web (opcional)',
    formMessenger: 'Mensajero preferido',
    formMessengerPlaceholder: 'Elige mensajero',
    formMessengerTelegram: 'Telegram',
    formMessengerWhatsapp: 'WhatsApp',
    formMessengerPhone: 'Llamada telefónica',
    formSubmit: 'Registrarse para diagnóstico',
    formSubmitting: 'Enviando...',
    formSuccess: '¡Solicitud enviada! Nos pondremos en contacto contigo pronto.',
    formError: 'Ocurrió un error. Inténtalo de nuevo.',
    formConsent: 'Al hacer clic en el botón, aceptas la política de privacidad'
  },

  // Footer
  footer: {
    companyTitle: 'Marketing Sistemático',
    companyDesc: 'Convertimos el caos en sistema. Combinamos experiencia experta con precisión de algoritmos de IA.',
    servicesTitle: 'Servicios',
    companyTitle2: 'Empresa',
    aboutUs: 'Sobre nosotros',
    cases: 'Casos',
    blog: 'Blog',
    contactsTitle: 'Contactos',
    address: '109202, Moscú, calle 2-ya Karacharovskaya, ed. 1 estr. 1, local 6/2',
    privacy: 'Política de privacidad',
    terms: 'Acuerdo de usuario',
    websiteBuilder: 'Website Builder',
    copyright: 'Marketing Sistemático. Todos los derechos reservados.'
  },

  // Common
  common: {
    readMore: 'Leer más',
    readLess: 'Ocultar',
    loading: 'Cargando...',
    required: 'requerido',
    optional: 'opcional'
  }
};
